import * as React from 'react'
import { connect } from 'react-redux'
import { RiskActions, RiskChallenge, RiskContext, RiskWorkflows } from '@doordash/component-risk'
import { Inset } from '@doordash/design-language'
import { push, Steps } from '../../../utilities/steps'
import * as events from '../../../events'
import * as DA from '../../../typeModules/events'

type ReduxProps = {
  trackSignupMultiFactorAuth: (data: DA.SignupMultiFactorAuth) => Promise<any>
}

type Props = {
  uniqueLink: string
}

const OVERRIDE_TYPE = '1'
const SMS_CHANNEL = 'sms'

const SignupPhoneVerify: React.FC<Props & ReduxProps> = ({ uniqueLink, trackSignupMultiFactorAuth }) => {
  const { dispatch } = React.useContext(RiskContext)

  React.useEffect(() => {
    trackSignupMultiFactorAuth({
      action: DA.EventActions.Rendered,
      name: DA.SignupMultiFactorAuthNames.VerifyPhone,
    })

    dispatch({
      type: RiskActions.RegisterCallback,
      onClose: () => {
        trackSignupMultiFactorAuth({
          action: DA.EventActions.Close,
          name: DA.SignupMultiFactorAuthNames.VerifyPhone,
        })
      },
      onSuccess: async () => {
        trackSignupMultiFactorAuth({
          action: DA.EventActions.Success,
          name: DA.SignupMultiFactorAuthNames.VerifyPhone,
        })
        push(uniqueLink, Steps.ProfileSetup)
      },
    })

    dispatch({
      type: RiskActions.PhoneEmailVerify,
      workflow: RiskWorkflows.DasherSignup,
    })
  }, [])

  return (
    <Inset>
      <RiskChallenge channel={SMS_CHANNEL} override={{ id: uniqueLink, type: OVERRIDE_TYPE }} requiresPageLayout />
    </Inset>
  )
}

const mapDispatchToProps = {
  trackSignupMultiFactorAuth: events.trackSignupMultiFactorAuth,
}

export default connect(null, mapDispatchToProps)(SignupPhoneVerify)
